import React from 'react';
import PropTypes from 'prop-types';

import './main-styles.css';

const InputSmall = ({ placeholder, onChange, type }) => {
    return (
        <div className="input-wrapper">
            <input className={type} type={type || 'text'} placeholder={placeholder} onChange={onChange}/>
        </div>
    )
};

InputSmall.propTypes = {
    placeholder: PropTypes.string,
    onChange: PropTypes.func,
    type: PropTypes.string
};

export default InputSmall;



// WEBPACK FOOTER //
// ./src/Components/Elements/Inputs/InputSmall.js